import React, { useEffect, useRef, useState } from 'react';
import scrollama from 'scrollama';
import './sec17.css';
import allArrows from './all_arrows.png';

const Sec17 = () => {
    const [isActive, setIsActive] = useState(false);
    const scrollerRef = useRef(null);

    useEffect(() => {
        if (scrollerRef.current) {
            const scroller = scrollama(); // Create a new Scrollama instance
            scroller.setup({
                step: scrollerRef.current,  // Use the ref's current value
                offset: 0.5,  // Trigger at the middle of the viewport
                once: true   // Trigger only once
            })
            .onStepEnter(() => {
                setIsActive(true); // Set active to true when in view
            });

            return () => scroller.destroy(); // Cleanup on unmount
        }
    }, []); // Rerun effect when scrollerRef.current changes

    return (
        <div className="sec17-section">
            <span style={{paddingBottom: "200px"}}> Without policy change, will we ever break this cycle? </span>
            <img
                ref={scrollerRef}
                src={allArrows}
                alt="All Arrow"
                style={{ width: '400px', height: 'auto', paddingBottom: "400px"}}
                className={isActive ? 'fade-in' : ''}
            />

        <p className="names">
            This project was developed with guidance, feedback, and data from the Metropolitan Area Planning Commission <a href="https://www.mapc.org/">(MAPC)</a>. The zip code data and racial demographic data are from the 2010 and 2020 Census. The redlining map data and area descriptions are from <a href="https://dsl.richmond.edu/panorama/redlining">Mapping Inequality</a>. The images are from Google Maps Street View.
            This website is created as part of Massachusetts Institute of Technology's Interactive Data Visualization & Society <a href="https://vis-society.github.io/">(Spring 2024)</a> coursework. We would like to express thanks to the instructors Arvind Satyanarayan and Catherine D’Ignazio as well as the course staff and our classmates for valuable comments and suggestions.
        </p>

        </div>
    );
};

export default Sec17;
